/**
 * SOLFIE — Barra minimalista de "quanto falta para o frete gratis".
 *
 * Usa a MESMA configuração do resto do carrinho (#solfie-cart-config, que vem do
 * painel Solfie): valor do frete grátis, textos e moeda. Atualiza junto com o
 * carrinho (cart:add / cart:update / cart:refresh / cart:updated).
 *
 * Onde a barra aparece: qualquer elemento com [data-solfie-frete-bar]
 * (hoje: PDP e página /cart, renderizado por snippets/solfie-frete-bar.liquid).
 */
(function () {
  'use strict';

  var cfg = document.getElementById('solfie-cart-config');
  if (!cfg) return;

  var ATIVO = cfg.dataset.freeShippingEnabled !== 'false';
  if (!ATIVO) return;

  var LIMITE = parseInt(cfg.dataset.freeShipping, 10) || 99900;
  var TEXTO_FALTA = cfg.dataset.textRemaining || 'Faltam {valor} para frete grátis';
  var TEXTO_OK = cfg.dataset.textUnlocked || 'Você ganhou frete grátis!';
  var MOEDA = cfg.dataset.currency || 'BRL';
  var LOCALE = cfg.dataset.locale || 'pt-BR';

  function dinheiro(centavos) {
    try {
      return (centavos / 100).toLocaleString(LOCALE, { style: 'currency', currency: MOEDA });
    } catch (e) {
      return 'R$ ' + (centavos / 100).toFixed(2).replace('.', ',');
    }
  }

  function barras() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-solfie-frete-bar]'));
  }

  function pintar(cart) {
    var total = (cart && cart.total_price) || 0;
    var falta = LIMITE - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / LIMITE) * 100)));

    barras().forEach(function (el) {
      var texto = el.querySelector('[data-role="texto"]');
      var fill = el.querySelector('[data-role="fill"]');
      var trilha = el.querySelector('[data-role="trilha"]');

      el.hidden = false;
      el.classList.toggle('is-ok', falta <= 0);

      if (texto) {
        texto.innerHTML =
          falta > 0
            ? TEXTO_FALTA.replace('{valor}', '<strong>' + dinheiro(falta) + '</strong>')
            : '<strong>' + TEXTO_OK + '</strong>';
      }
      if (fill) fill.style.width = pct + '%';
      if (trilha) trilha.setAttribute('aria-valuenow', String(pct));
    });
  }

  /* injeta a barra no cart drawer (na PDP e no /cart ela vem do Liquid).
     Mesmo visual, mesmo valor do painel e a mesma posicao segura: ULTIMO filho
     da lista de itens (o morph do tema casa filhos por POSICAO). */
  function garantirNoDrawer(cart) {
    var comp = document.querySelector('cart-items-component[data-drawer]');
    if (!comp) return;

    var existente = comp.querySelector('[data-solfie-fb-drawer]');
    if (!cart.item_count) {
      if (existente) existente.remove();
      return;
    }
    if (existente) return;

    var el = document.createElement('div');
    el.className = 'solfie-fb solfie-fb--drawer';
    el.setAttribute('data-solfie-frete-bar', '');
    el.setAttribute('data-solfie-fb-drawer', '');
    el.innerHTML =
      '<p class="solfie-fb__texto" data-role="texto"></p>' +
      '<div class="solfie-fb__trilha" data-role="trilha" role="progressbar" aria-valuemin="0" aria-valuemax="100">' +
        '<span class="solfie-fb__fill" data-role="fill"></span>' +
      '</div>' +
      '<p class="solfie-fb__meta">Frete grátis a partir de ' + dinheiro(LIMITE) + '</p>';

    var destino = comp.querySelector('.cart-drawer__items') || comp.querySelector('.cart-drawer__content');
    if (!destino) return;
    destino.appendChild(el);
  }

  function atualizar() {
    window
      .fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        garantirNoDrawer(cart);
        pintar(cart);
      })
      .catch(function () {});
  }

  atualizar();

  ['cart:add', 'cart:update', 'cart:refresh', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function () { window.setTimeout(atualizar, 140); });
  });
  document.addEventListener('shopify:section:load', function () { window.setTimeout(atualizar, 220); });
})();
